import React from 'react';
import PropTypes from 'prop-types';

const FilterBox = ({ label, value, valueLabel, className, onClick }) => (
  <button className={`${className} btn btn-white filter-box`} onClick={onClick}>
    {valueLabel ? (
      <>
        <strong>{label}: </strong>{valueLabel}
      </>
    ) : (
      label ? (
        <>
          <strong>{label}: </strong>{value}
        </>
      ) : (
        <strong>{value.label}</strong>
      ))}
    <i className="ml-2 fas fa-times" />
  </button>
);

FilterBox.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

FilterBox.defaultProps = {
  className: '',
};

export default FilterBox;
